import React, { createContext, useContext } from "react";
import { useJsApiLoader } from "@react-google-maps/api"
const GoogleMapsContext = createContext();

const LIBRARIES = ["drawing", "places", "geometry"];

export const GoogleMapsProvider = ({ children }) => {
  const { isLoaded, loadError } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAP_API_KEY,
    libraries: LIBRARIES,
    version: "weekly",
    mapIds: ['ac9ff67125fef15a2ae1c64a']
  });

  if (loadError) {
    console.error("Error loading Google Maps API:", loadError);
    return <div>Error loading Google Maps API. Please check API key, console, and library names.</div>;
  }
  
  if (!isLoaded) {
    return null;
  }

  return (
    <GoogleMapsContext.Provider value={{ isLoaded, loadError }}>
       {children}
    </GoogleMapsContext.Provider>
  );
};

export const useGoogleMaps = () => useContext(GoogleMapsContext);



